import axios from "axios";
const API_URL = process.env.REACT_APP_API_URL;

// Crear línea de presupuesto
export const createBudgetLine = async (presupuestoId, lineData) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.post(
      `${API_URL}/api/presupuestos/${presupuestoId}/lineas`,
      lineData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al crear la línea de presupuesto:", error);
    throw error;
  }
};

// Actualizar línea de presupuesto
export const updateBudgetLine = async (id, lineData) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_API_URL}/api/lineas/${id}`,
      lineData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Si usas autenticación
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al actualizar la línea:", error);
    throw error;
  }
};

// api/budgetLinesApi.js
export const fetchBudgetLines = async (presupuestoId) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(
      `${API_URL}/api/presupuestos/${presupuestoId}/lineas`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data || [];
  } catch (error) {
    console.error("Error al obtener las líneas de presupuesto:", error);
    throw error;
  }
};

// Eliminar línea de presupuesto
export const deleteBudgetLine = async (lineaId) => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.delete(`${API_URL}/api/lineas/${lineaId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al eliminar la línea de presupuesto:", error);
    throw error;
  }
};

export const fetchAllBudgetLines = async () => {
  const token = localStorage.getItem("token");
  const res = await axios.get(`${API_URL}/api/presupuestos/lineas-todas`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res.data; // objeto { IdPresupuesto: [lineas...] }
};
